import { gql } from '@apollo/client'

export const GET_ALL_WATER_STATIONS = gql`
  query GetAllWaterStations($limit: Int, $offset: Int, $searchQuery: String) {
    getAllWaterStations(
      limit: $limit
      offset: $offset
      searchQuery: $searchQuery
    ) {
      count
      rows {
        id
        name
        location
        address
        status
        operating_hours
        manager
        contact_info
      }
    }
  }
`

export const GET_WATER_STATION_BY_ID = gql`
  query GetWaterStationById($getWaterStationByIdId: Int!) {
    getWaterStationById(id: $getWaterStationByIdId) {
      id
      name
      location
      address
      manager
      operating_hours
      status
      contact_info
    }
  }
`

export const GET_STATUS_WATER_STATION = gql`
  query Query {
    getStatusForWaterStation {
      value
      label
    }
  }
`

export const CREATE_WATER_STATION = gql`
  mutation CreateWaterStation($waterStation: WaterStationInput!) {
    createWaterStation(waterStation: $waterStation)
  }
`
export const UPDATE_WATER_STATION = gql`
  mutation UpdateWaterStation(
    $updateWaterStationId: Int!
    $waterStation: WaterStationInput!
  ) {
    updateWaterStation(id: $updateWaterStationId, waterStation: $waterStation)
  }
`
export const DELETE_WATER_STATION = gql`
  mutation DeleteWaterStation($deleteWaterStationId: Int!) {
    deleteWaterStation(id: $deleteWaterStationId)
  }
`
